import React from 'react'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

const ExpressLiveTracking = ({ drivers, data }) => {
  if (data && !data.driverUid) return null

  const { driverUid, merchantLocation, receiverLocations, merchantName } = data
  const driver = drivers[driverUid]

  return (
    <React.Fragment>
      <MarkerWithLabel
        location={driver.location}
        icon={helpers.getIconByStatus(driver.status)}
        label={`${driver.family_name} ${driver.first_name}`}
        labelColor={helpers.getLabelColor(driver.status)}
      />

      <MarkerWithLabel
        location={merchantLocation}
        icon={helpers.icons.restaurant}
        label={merchantName}
        labelColor={helpers.getLabelColor()}
      />
      {receiverLocations.map(receiverLocation => {
        const { receiver_name: receiverName, order_number: orderNumber } = receiverLocation
        const markerLabel = `${orderNumber}. ${receiverName}`
        return (
          <MarkerWithLabel
            location={receiverLocation}
            icon={helpers.icons.userHome}
            label={markerLabel}
            labelColor={helpers.getLabelColor()}
          />
        )
      })}
    </React.Fragment>
  )
}

export default ExpressLiveTracking



// WEBPACK FOOTER //
// ./src/containers/mapView/components/ExpressLiveTracking.js